import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './api/index.js'
// import BaiduMap from 'vue-baidu-map'
import Vuex from 'vuex'
import animated from 'animate.css'

Vue.prototype.$api = api

Vue.config.productionTip = false

// Vue.use(BaiduMap, { ak: '' })

Vue.use(Vuex)
Vue.use(animated)

const store = new Vuex.Store({
  state: {
    isEn: 0,
    area: 0,
    articleTypeId: 0,
    isLoaded: false,
    routeList: [],
    publicInfo: [],
    banner: []
  },
  mutations: {
    changeLan (state) {
      if (state.isEn === 0) state.isEn = 1
      else if (state.isEn === 1) state.isEn = 0
      sessionStorage.removeItem('reportList')
      localStorage.setItem('lan', state.isEn)
    },
    changeLan1 (state, n) {
      state.isEn = n
      localStorage.setItem('lan', n)
    },
    changeArea (state, n) {
      state.area = n
    },
    changeId (state, n) {
      state.articleTypeId = n
    },
    isLoad (state) {
      state.isLoaded = true
    },
    setRouteList (state, routeList) {
      state.routeList = routeList
      localStorage.setItem('routeList', JSON.stringify(routeList))
    },
    setPublicInfo (state, publicInfo) {
      state.publicInfo = publicInfo
      localStorage.setItem('publicInfo', JSON.stringify(publicInfo))
    },
    // setBanner (state, banner) {
    //   state.banner = banner
    // }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
